module.exports = __webpack_public_path__ + "assets/img/4210-sh.svg";